import usdcIcon from "../../../media/icons/usd.png";

export function USDCIcon() {
    return (
        <img src={usdcIcon} width={38} height={38} alt='USDC'/>
    )
}
